import React from "react";
import logo from '../assets/images/icon.png';

const Header = () => {

    // Function to remove the cookie and refresh the page
    const handleLogout = () => {
        document.cookie = "auth_pass=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        window.location.reload(); // Refresh the page
    };

    return (
        <div className="navbar navbar-dark navbar-expand-md" style={{ "backgroundColor": "rgba(109, 109, 109, 1)" }} role="navigation">
            <a className="navbar-brand" style={{ 'fontFamily': "Montserrat", 'fontStyle': "normal", 'fontWeight': "bold", 'fontSize': 22 }} href="/map">
                <img src={logo} width="30" alt="logo" style={{ "marginRight": 16 }} />
                LIFT ADMIN PANEL
            </a>

            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#mainmenu" aria-controls="mainmenu" aria-expanded="false" aria-label="Menu">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="mainmenu">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" href="/map">Wyświetlanie</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/malfunctions">Awarie</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link disabled" href="/map">Edycja</a>
                    </li>
                </ul>
            </div>

            <div className="d-flex align-items-center">
                <a className="navbar-text me-3" style={{
                    'fontFamily': "Montserrat",
                    'fontStyle': "normal",
                    'fontWeight': 500,
                    'fontSize': 16
                }} href="https://gdzietometro.pl/">
                    GdzieToMetro.pl
                </a>
                <button 
                    className="btn btn-danger btn-sm" 
                    onClick={handleLogout} 
                    style={{
                        fontFamily: "Montserrat",
                        fontWeight: "bold",
                        fontSize: "14px",
                        padding: "5px 10px",
                        marginLeft: "10px"
                    }}>
                    Wyloguj się
                </button>
            </div>
        </div>
    );
};

export default Header;
